import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

import S from './Input.styled'

const Input = forwardRef(
  (
    {
      value,
      className = '',
      type = 'text',
      name = '',
      placeholder = '',
      isDisabled = false,
      isReadOnly = false,
      onChange,
      onFocus = () => {},
      onBlur = () => {},
      onKeyDown = () => {},
    },
    ref
  ) => {
    return (
      <S.Input
        ref={ref}
        value={value}
        className={className}
        type={type}
        name={name}
        placeholder={placeholder}
        disabled={isDisabled}
        readonly={isReadOnly}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
      />
    )
  }
)

Input.propTypes = {
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  isDisabled: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
}

export default Input
